import { render } from "./projet.vue?vue&type=template&id=5d80a3be&scoped=true"
import script from "./projet.vue?vue&type=script&lang=js"
export * from "./projet.vue?vue&type=script&lang=js"

import "./projet.vue?vue&type=style&index=0&id=5d80a3be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d80a3be"]])

export default __exports__